module.exports = __webpack_public_path__ + "assets/feedbackicon-4.1fa718c7.svg";